import React, { ReactElement } from 'react'

import ButtonOLD, { ButtonProps } from '../../atoms/ButtonOLD'
import Icon from '../../atoms/Icon'
import { Dropdown } from 'antd'

export type DropdownButtonProps = {
  buttonText: string
  overlay: ReactElement
  style?: React.CSSProperties
  type: ButtonProps['type']
}

export default function DropdownButton({
  buttonText,
  overlay,
  style,
  type,
}: DropdownButtonProps): ReactElement {
  const containerStyle = {
    ...styles.container,
    ...style,
  }

  return (
    <div style={containerStyle}>
      <Dropdown overlay={overlay} trigger={['click']}>
        <ButtonOLD type={type}>
          <div style={styles.dropdownBtn}>
            <div>{buttonText}</div>
            <Icon name="DownOutlined" style={styles.dropdownIcon} />
          </div>
        </ButtonOLD>
      </Dropdown>
    </div>
  )
}

const styles = {
  dropdownBtn: {
    display: 'flex',
    alignItems: 'center',
  },
  dropdownIcon: {
    marginLeft: 8,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
  },
}
